import type { LanguageTag } from "../../shared/core/i18n/translations";
import { i18NManager } from "../../shared/core/service/services";

export const getLanguageName = (languageTag: LanguageTag) =>
  i18NManager.formatMessage(`common.languages.${languageTag}`);
